import { CREATE_FIBER_POP } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const createFiberPop = async (formData) => {
  try {
    const response = await apiClient.post(CREATE_FIBER_POP, formData);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
